import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";

// import ReviewsPanel from "../reviews/panels/ReviewsPanel";
import iconHeartSelected from "assets/icons/heart-selected.svg";
import iconHeartUnselected from "assets/icons/heart-unselected.svg";
import _ from "lodash";
import styled from "styled-components";

import ReviewsSection from "components/tools/reviews-section";
import { Breadcrumb, Button, Container, Frame, Row, RowWrapper, TExtra } from "components/ui-kit/styled-templates";
import Table from "components/ui-kit/table";

import { MEAL_PLAN_OPTIONS, resolveFileUrl } from "constants/config";
import theme from "constants/theme-constants";

import DormitoriesApi from "api/dormitories-api";
import ReviewsAPI from "api/reviews-api";
import RoomsApi from "api/rooms-api";
import UniversityApi from "api/university-api";
import UserApi from "api/user-api";

import ModalsService from "services/modals-service";

import useBodyBackground from "hooks/useBodyBackground";
import useDeviceParams from "hooks/useDeviceParams";
import usePagination from "hooks/usePagination";
import { useStorageListener } from "hooks/useStorage";

import { EModals, ERoles } from "types/enums";

const DormitoryPublicPage = (props) => {
    const { t, i18n } = useTranslation();

    let isRu = i18n.language === "ru";

    let { dormitoryId } = useParams();
    if (dormitoryId == undefined) {
        dormitoryId = props.dormitoryId;
    }
    const user = useStorageListener(`user`, {});
    const role: ERoles = useStorageListener(`user.userRole`, ERoles.Guest);
    const reviews = useStorageListener(`reviews`, []);
    const navigate = useNavigate();
    const { isDesktop } = useDeviceParams();
    useBodyBackground(`white`);

    const { universityId, details: dormitory, rooms } = useStorageListener(`dormitories.${dormitoryId}`, {});
    const university = useStorageListener(`universities.${universityId}.details`, {});

    const photos = _.get(dormitory, `main-info.photos`, []);
    const photosPagination = usePagination(photos, { perPage: 4 });
    const {
        visibleItems: visiblePhotos,
        isFirstPage: isFirstPhotoPage,
        isLastPage: isLastPhotoPage,
        handleNextPage,
        handlePrevPage
    } = photosPagination;

    const startDormitory = () => {
        UserApi.toggleDormitoryStar(dormitoryId);
    };

    useEffect(() => {
        if (!dormitory) {
            try {
                DormitoriesApi.getDormitoryInfo(dormitoryId);
            } catch (error) {
                navigate(`/search`);
            }
        }
    }, [dormitoryId, dormitory, navigate]);

    useEffect(() => {
        if (!dormitory) {
            RoomsApi.getDormitoryRooms(dormitoryId);
        }
    }, [dormitoryId, dormitory]);

    useEffect(() => {
        UniversityApi.getAllUniversitiesData();
        ReviewsAPI.getAllReviews();
    }, []);

    useEffect(() => {
        // scroll to top after render and after article loaded
        try{
            setTimeout(() => {
                console.log('scroll to top!!!');
                window.scrollTo({
                    top: 0,
                    behavior: 'auto'
                });
                const element = document.getElementById("header_logo");
                if (element) {
                    element.scrollIntoView({
                        behavior: "auto", // Optional for smooth scrolling
                        block: "start",     // Aligns the element at the top
                    });
                }
            }, 100);
        }catch(exc){

        }
    }, []);

    const dormitoryReviews = reviews.filter((i) => i.published).filter((i) => i.dormitoryId === dormitoryId);
    console.log(dormitoryReviews);

    return (
        <>
            <Container>
                <Breadcrumb.Wrapper>
                    <Breadcrumb.Item to="/">{t("mr970ab6um")}</Breadcrumb.Item>
                    <Breadcrumb.Item to="/universities">{t("vs9okd5und")}</Breadcrumb.Item>
                </Breadcrumb.Wrapper>
            </Container>
            <Row extra={`width: inherit; background: #F4F4F4;`}>
                <Container extra={`align-items: flex-start;`}>
                    <HeaderRowWrapper dormitory={dormitory}>
                        <div className="flex flex-row gap-2 items-center">
                            <h1>{_.get(dormitory, `main-info.name`, `...`)}</h1>
                            {role === ERoles.Guest ? null :
                                <img
                                    src={_.get(user, "starredDormitories", []).includes(dormitoryId) ? iconHeartSelected : iconHeartUnselected}
                                    alt="Start"
                                    className="w-10 h-10 object-fit cursor-pointer"
                                    onClick={startDormitory}
                                    style={{ marginRight: "15px", marginLeft: "15px" }}
                                />
                            }
                        </div>
                        <Row extra={`gap: 16px;`}>
                            <Link to={role === ERoles.Guest ? `/login` : `/create-booking/${dormitoryId}`}>
                                <Button>{t("xzqyj036ra")}</Button>
                            </Link>
                            {/* <Button variant="outlined">Написать отзыв</Button> */}
                        </Row>
                    </HeaderRowWrapper>
                    <NavMenuWrapper>
                        {[
                            { text: isRu ? `Общая информация` : `General information`, hash: `main-info` },
                            { text: isRu ? `Комнаты` : "Rooms", hash: `rooms` },
                            // { text: `Мероприятия`, hash: `events` },
                            { text: isRu ? `Условия заселения` : "Rules of accomodation", hash: `rules` },
                            { text: isRu ? `Документы` : "Documents", hash: `documents` }
                        ].map((item, index) => (
                            <a href={`#${item?.hash}`} style={{ color: "#723DD3", fontFamily: "'Noto Sans', sans-serif" }} key={index}>
                                {item?.text}
                            </a>
                        ))}
                    </NavMenuWrapper>
                </Container>
            </Row>
            <Container extra={`align-items: flex-start; margin-bottom: 50px;`}>
                {role === ERoles.Admin && (
                    <Link to={`/dormitory/${dormitoryId}/edit`}>
                        <Button extra="margin: 25px 0;">{t("5oaigs9og2")}</Button>
                    </Link>
                )}
                <h2 id="main-info">{t("nbbydet7aka")}</h2>
                <Row
                    extra={`width: 100%; gap: 32px; flex-direction: row; @media (max-width: 991px) { flex-direction: column; };`}>
                    <MainInfo.Photo src={resolveFileUrl(_.get(dormitory, `main-info.photos[0]`, ``))} />
                    <MainInfo.DetailsWrapper>
                        {[
                            {
                                title: isRu ? `Образовательная организация` : `Educational organization`,
                                text: university?.name,
                                link: university?.site
                            },
                            {
                                title: isRu ? `Субъект` : `Region`,
                                text: university?.region
                            },
                            {
                                title: isRu ? `Город` : `City`,
                                text: _.get(dormitory, `main-info.city`)
                            },
                            {
                                title: isRu ? `Питание` : `Meal plan`,
                                text: MEAL_PLAN_OPTIONS.find((i) => i?.value === _.get(dormitory, `main-info.mealPlan`))?.label
                            },
                            {
                                title: isRu ? `Адрес` : `Address`,
                                text: `${_.get(dormitory, `main-info.street`, `...`)}, ${_.get(dormitory, `main-info.houseNumber`, `...`)}`
                            },
                            {
                                title: isRu ? `Продолжительность пребывания` : `Duration of stay`,
                                text: `от ${_.get(dormitory, `main-info.minDays`, `0`)} до ${_.get(dormitory, `main-info.maxDays`, `1`)} дней`
                            }
                        ].map((item, index) => (
                            <MainInfo.DetailsItem key={index}>
                                <div>{item?.title}</div>
                                <strong>{item?.text}</strong>
                                <a href={item?.link}>{item?.link}</a>
                            </MainInfo.DetailsItem>
                        ))}
                    </MainInfo.DetailsWrapper>
                </Row>
                <RowWrapper
                    extra={`margin-top: 56px; @media (max-width: 991px) { width: 100vw; margin-left: -7vw; overflow-x: scroll; };`}>
                    {isDesktop &&
                        <Gallery.SvgArrow direction="left" isActive={!isFirstPhotoPage} onClick={handlePrevPage} />}
                    <Row
                        extra={`width: 100%; gap: 0 27px; @media (max-width: 991px) { width: max-content; > * { &:first-child { margin-left: 7vw; }; &:last-child { margin-right: 7vw; }; }; };`}
                    >
                        {(isDesktop ? visiblePhotos : photos).map((item: string, index: number) => (
                            <Gallery.Photo
                                key={index}
                                src={resolveFileUrl(item)}
                                onClick={() =>
                                    ModalsService.showModal(EModals.OverlayedGallery, {
                                        photos,
                                        currentPhotoNumber: index
                                    })
                                }
                            />
                        ))}
                    </Row>
                    {isDesktop &&
                        <Gallery.SvgArrow direction="right" isActive={!isLastPhotoPage} onClick={handleNextPage} />}
                </RowWrapper>
                <h2 id="rooms">{t("ejbrjmg4jh")}</h2>
                <Table
                    name={`dormitoryPublicRoomsTable`}
                    withPagination={false}
                    rows={_.values(rooms).map(({ details: { amount, description, type, price, photos, currency, isFree } }) => ({
                        type,
                        amount,
                        price,
                        description,
                        photos,
                        priceLabel: (isFree == true) ? t("b6cio60ug9a") : `${price} (${currency || 'руб.'})`,
                        // photo: `Фото и видео`,
                    }))}
                    columns={[
                        { name: `type`, label: isRu ? `Тип комнаты` : "Room type", extra: `flex: 2;` },
                        { name: `amount`, label: isRu ? `Количество` : "Quantity" },
                        { name: `priceLabel`, label: isRu ? `Тариф (1 человек) ` : "Tariff", extra: `flex: 3;` },
                        { name: `description`, label: isRu ? `Описание` : `Description`, extra: `flex: 7;` },
                        {
                            name: `photo`,
                            label: ``,
                            extra: `justify-content: flex-end; color: ${theme.blue}; cursor: pointer;`,
                            transform: (d) => (isRu ? `Фото` : `Photo`),
                            onCellClick: ({ row: { photos } }) =>
                                ModalsService.showModal(EModals.OverlayedGallery, { photos, currentPhotoNumber: 0 })
                        }
                    ]}
                />
                {/* <h2 id="events">Мероприятия</h2> */}
                {dormitory?.services?.length > 0 && (
                    <>
                        <h2 id="events">{t("zipgyz55669")}</h2>
                        <Table
                            name="dormitory-public-page-services"
                            withPagination={false}
                            useBackendProcessing={false}
                            rows={dormitory?.services.map(x => ({...x, priceLabel: x.isFree ? t("b6cio60ug9a") : `${x.price} (${x.currency || 'руб.'})` }))}
                            columns={[
                                { name: "name", label: t("x1lrrmnwdwo") },
                                { name: "priceLabel", label: t("wg7kzt4zsm8") },
                                { name: "description", label: t("9k4ohj1l27l"), extra: "flex: 2;" }
                            ]}
                        />
                    </>
                )}
                <h2 id="rules">{t("2d5ltee2hj7")}</h2>
                <h3>{t("30avrhfvqcj")}</h3>
                <Frame
                    extra={`max-width: 96vw; white-space: pre-line;`}>{dormitory?.rules?.requiredUniDocuments}</Frame>
                <h3>{t("djcwv5xdo5m")}</h3>
                <Frame
                    extra={`max-width: 96vw; white-space: pre-line;`}>{dormitory?.rules?.requiredStudentsDocuments}</Frame>
                <Contacts.Wrapper>
                    <h3>{t("8xowa84jwc9")}</h3>
                    <Contacts.Row>
                        <div>
                            <div>{t("t1chxdzp6v")}</div>
                            <div>{dormitory?.rules?.committee?.name}</div>
                        </div>
                        <div style={{ minWidth: "300px" }}>
                            <div>{t("su7c0p6mrfj")}</div>
                            <div>{dormitory?.rules?.committee?.phone}</div>
                        </div>
                        <div>
                            <div>{t("y6s29465wo")}</div>
                            <a href={`mailto:${dormitory?.rules?.committee?.email}`} target="_blank" className="link"
                               rel="noreferrer">
                                {dormitory?.rules?.committee?.email}
                            </a>
                        </div>
                    </Contacts.Row>
                </Contacts.Wrapper>
                <h2 id="documents">{t("tov4rwt08j9")}</h2>
                {dormitory?.documents?.map?.((item: any, index: number) => {
                    return (
                        <DocumentWrapper key={index} onClick={() => window.open(item, `_blank`)}>
                            {t("row7rnrbzyb")} {index + 1}
                        </DocumentWrapper>
                    );
                })}
                {/* <Contacts.Wrapper extra={`width: min-width;`}>
                    <h3>Контакты службы поддержки</h3>
                    <Contacts.Row>
                        <div>
                            <div>Телефон</div>
                            <div>8-800-707-71-61</div>
                        </div>
                        <div>
                            <div>Электронная почта</div>
                            <a href={"mailto:info@mst22.ru"} target="_blank" >info@mst22.ru</a>
                        </div>
                    </Contacts.Row>
                </Contacts.Wrapper> */}

                {/* <div style={{ width: "100%" }}>
                    <ReviewsPanel refId={dormitoryId} />
                </div> */}

                {dormitory?.accessibilityEnabled && (
                    <>
                        <div style={{ marginTop: 10, marginBottom: 10 }}>
                            <h3>{isRu ? "Информация для лиц с ограниченными возможностями здоровья" : `Information for people with disabilities`}</h3>
                            <div>
                                {dormitory?.accessibilityComment}
                            </div>
                        </div>
                    </>
                )}

                {dormitory?.video && (
                    <>
                        <div style={{ marginTop: 10, marginBottom: 10 }}>
                            <h3>{t("gj7fwspuj2")}</h3>
                            <Video src={dormitory?.video} controls extra="margin-top: 15px;" />
                        </div>
                    </>
                )}

                <ReviewsSection reviews={dormitoryReviews} />

            </Container>
        </>
    );
};

const Video = styled.video<{ extra?: TExtra }>`
  width: 100%;

  ${({ extra }) => extra}
`;


const HeaderRowWrapper = styled(RowWrapper)<{ dormitory: Object }>`
  ${({
       theme,
       dormitory
     }) => _.isEmpty(_.get(dormitory, `main-info.name`)) && `color: ${theme.red};`} @media(max-width: 991 px) {
  flex-direction: column;

  h1 {
    margin: 20px 0;
    line-height: 56px;
  }

  div {
    margin: 0 0 32px 0;
  }
}
`;

const DocumentWrapper = styled(Frame)`
  flex-direction: row;
  cursor: pointer;
  margin-bottom: 5px;

  &:before {
    content: "";
    width: 30px;
    height: 30px;
    background: url("${require(`assets/icons/dropzone-file.svg`).default}") no-repeat center center / contain;
    margin-right: 12px;
  }
`;

const Contacts = {
    Wrapper: styled(Frame)`
      width: inherit;
      padding: 32px;
      box-sizing: border-box;
      border-radius: 8px;
      background: #f4f4f4;
      align-items: flex-start;
      gap: 5px;
      margin-top: 56px;

      h3 {
        margin-top: 0;
      }
    `,
    Row: styled(Row)`
      gap: 10px;
      align-items: flex-start;

      > * {
        display: flex;
        flex-direction: column;
        gap: 8px;

        > * {
          &:nth-child(2) {
            font-weight: 600;
          }
        }
      }

      .link {
        color: ${({ theme }) => theme.blue};
      }

      @media (max-width: 991px) {
        flex-direction: column;
      };
    `
};

const Gallery = {
    Wrapper: styled(Frame)``,
    Photo: styled(Frame)<{ src: string }>`
      width: 276px;
      height: 195px;
      border-radius: 8px;

      background: url("${({ src }) => src}") no-repeat center center / cover;
    `,
    SvgArrow: styled.svg.attrs((props) => {
        return {
            ...props,
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: (
                <>
                    <defs>
                        <style>{`.cls-1{fill:none;}`}</style>
                    </defs>
                    <g id="wrapper">
                        <rect className="cls-1" width="24" height="24" />
                    </g>
                    <path
                        d="M14.55,12,11.2,9.1,6.78,5.32a1.29,1.29,0,0,1-.51-1.18,1.28,1.28,0,0,1,2.12-.81l2.32,2,6.51,5.57a1.27,1.27,0,0,1,.53,1.37,1.67,1.67,0,0,1-.44.72q-4.48,3.87-9,7.7a1.26,1.26,0,0,1-1.81-.13,1.28,1.28,0,0,1,.18-1.84L14.3,12.2Z" />
                </>
            )
        };
    })<{ direction: `left` | `right`; isActive: boolean }>`
      ${({ direction }) => direction === `left` && `transform: rotate(180deg);`}

      width: 30px;
      height: 30px;

      cursor: pointer;

      path {
        fill: ${({ theme, isActive }) => (isActive ? theme.blue : theme.grey)};
      }
    `
};

const MainInfo = {
    Photo: styled(Frame)<{ src: string }>`
      width: 100%;
      max-width: 87vw;
      height: 380px;
      flex: 1;
      border-radius: 12px;
      background: url("${({ src }) => src}") no-repeat center center / cover;

      @media (max-width: 991px) {
        max-height: 180px;
        flex: unset;
      }
    `,
    DetailsWrapper: styled(Frame)`
      width: 100%;
      max-width: 87vw;
      min-height: 380px;
      flex: 1;
      border-radius: 12px;
      background: ${({ theme }) => theme.lightblue};

      padding: 32px;
      box-sizing: border-box;

      flex-direction: row;
      flex-wrap: wrap;
      align-items: flex-start;

      gap: 5px;

      @media (max-width: 991px) {
        gap: 15px;
      }
    `,
    DetailsItem: styled(Frame)`
      width: calc(50% - 3px);
      align-items: flex-start;
      font-size: 15px;
      line-height: 20px;

      a {
        color: ${({ theme }) => theme.blue};
        font-weight: 600;
      }

      strong {
        margin: 8px 0 16px;
        min-height: 20px;
      }

      @media (max-width: 991px) {
        width: 100%;
      }
    `
};

const NavMenuWrapper = styled(Row)`
  gap: 5px 40px;
  color: #0d5adc;
  margin-bottom: 40px;
  font-weight: 600;
  font-size: 18px;
  line-height: 32px;
  flex-wrap: wrap;
  justify-content: flex-start;

  > * {
    cursor: pointer;
  }
`;

export default DormitoryPublicPage;
